module.exports = __webpack_public_path__ + "img/bo_concept_vertical_billede.106ddf40.jpg";